import React, { useEffect, useState } from "react";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import Notification from "../../elements/notification/Notification";
import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import ProjectsSelect from "../../elements/projects/ProjectsSelect";
import { TextField } from "@material-ui/core";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { StyledRangeFeeInvoiceWrapper } from "../../clients/styledClients";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import CurrenciesSelect from "../../elements/currencies/CurrenciesSelect";
import ServicesSelect from "./ServicesSelect";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const RatesServiceEdit = ({ fetchRates, currencyType }) => {
  const { t } = useTranslation("ratesPage");
  const [open, setOpen] = useState(false);

  const defaultData = {
    "service": null,
    "project": null,
    "currency": null
  };

  const [invoiceData, setInvoiceData] = useState(defaultData);
  const [disabled, setDisabled] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    setDisabled(false);
  }, [notification]);

  const updateService = async () => {
    setDisabled(true);

    let check2Fa = await check2FA(getUserInfo()["userId"], invoiceData.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.get(`api/rates/change-service/${invoiceData.project.id}/${invoiceData.service.id}/${invoiceData.currency.asset}?type=` + currencyType, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        fetchRates();
        setNotification(
          { ...notification, visible: true, type: "success", message: t("rates.changeService.success") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => handleClose());
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setInvoiceData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledRangeFeeInvoiceWrapper className="rates-head_client__change-service">
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("rates.changeService.title")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("rates.changeService.description")}
            </StyledDialogHead>
            <StyledDialogContent>
              <ProjectsSelect
                checkedProjects={invoiceData.project}
                setCheckedProjects={(data) => setInvoiceData({ ...invoiceData, "project": data })}
                isObject={true}
                userId={getUserInfo()["userId"]}
              />
              <CurrenciesSelect
                checkedCurrencies={invoiceData.currency}
                setCheckedCurrencies={(data) => setInvoiceData({ ...invoiceData, "currency": data })}
                isObject={true}
              />
              <ServicesSelect
                checkedService={invoiceData.service}
                setCheckedService={(data) => setInvoiceData({ ...invoiceData, "service": data, page: 1 })}
                rateService={true}
              />
              <TextField
                id="twofa"
                label={t("rates.changeService.twoFa")}
                value={invoiceData.twofa}
                onChange={(data) => setInvoiceData({ ...invoiceData, "twofa": data.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("rates.changeService.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={updateService}
                color="success"
                disabled={disabled}
              >
                {t("rates.changeService.change")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledRangeFeeInvoiceWrapper>
    </>
  );
};

export default RatesServiceEdit;